import { PREDEFINED_TENANTS } from 'swag-common/constants/main-swag.constants';
export function checkIsSwagOrResellerOrder(order) {
  return ![PREDEFINED_TENANTS.SENDOSO, PREDEFINED_TENANTS.CUSTOM_INK, PREDEFINED_TENANTS.POSTAL].includes(order.tenant);
}